import { createAction, createSlice } from "@reduxjs/toolkit";
import { whitelabelAncillaryService } from "../../service/whitelabelAncillariesService.js";
export const whitelabelAncillariesInitialState = () => {
    return {
        whitelabelAncillariesLoading: false,
        status: "INIT",
        whitelabelAncillaries: []
    };
};
export const RESET = createAction("RESET");
export const whitelabelAncillariesSlice = createSlice({
    name: "whitelabelAncillariesEligibility",
    initialState: whitelabelAncillariesInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        const getWhitelabels = whitelabelAncillaryService.getWhitelabels;
        builder.addCase(RESET, () => whitelabelAncillariesInitialState());
        builder.addCase(getWhitelabels.pending, (state) => {
            state.whitelabelAncillariesLoading = true;
            state.status = "LOADING";
        });
        builder.addCase(getWhitelabels.rejected, (state) => {
            state.whitelabelAncillariesLoading = false;
            state.status = "FAILED";
        });
        builder.addCase(getWhitelabels.fulfilled, (state, action) => {
            state.whitelabelAncillariesLoading = false;
            state.status = "FULFILLED";
            state.whitelabelAncillaries = action.payload.white_labels;
        });
    }
});
export default whitelabelAncillariesSlice.reducer;
